module.exports = __webpack_public_path__ + "static/media/S4N2.8d1f0ca6.svg";